<template>
  <div>
    <bg-loader :dark="true" v-if="isLoading"></bg-loader>
    <bg-list
      v-if="!isLoading"
      :headers="headers"
      :items="participants"
      :actions="actions"
      @actionClick="handleActions"
      :actionPerms="true"
    />
  </div>
</template>

<style scoped></style>

<script>
import BgList from "@/components/bg-list";
import BgTypography from "@/directives/bg-typography";
import API from "@/api";
import BgLoader from "@/components/bg-loader";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "participants",
  components: {
    BgLoader,
    BgList,
  },
  directives: {
    BgTypography,
  },
  data() {
    return {
      isLoading: true,
      data: null,
      participants: [],
      dropdownValue: false,
      actions: [
        {
          type: "edit",
          icon: "edit",
          tooltip: "Edit member",
        },
        {
          type: "delete",
          icon: "trashcan",
          tooltip: "Delete member",
        },
      ],
      headers: [
        {
          value: "id",
          icon: "account",
          format: (value) => `Participant ${value}`,
        },
        {
          label: "Time to complete",
          value: "time_to_complete",
        },
        {
          value: "age",
          label: "Age",
        },
        {
          value: "gender",
          label: "Gender",
          format: (value) => value.replace(/^\w/, (c) => c.toUpperCase()),
        },
        {
          value: "education",
          label: "Education",
        },
      ],
    };
  },
  mounted() {
    API.test.getTest(this.$route.params.id).then((res) => {
      this.isLoading = false;
      const withTtc = res.participants.map((p) => {
        return {
          ...p,
          ...p.demographic,
          time_to_complete: this.timeToComplete(p),
        };
      });

      this.participants = withTtc;
    });
  },
  methods: {
    handleActions(user) {
      if (user.actionType === "delete") {
        this.isModalOpen = true;
        this.userToDelete = user.id;
      }
      if (user.actionType === "edit") {
        this.$router.push({ path: `/edit-member/${user.id}` });
      }
    },
    timeToComplete(p) {
      const startTime = moment(p.started_at);
      const endTime = moment(p.ended_at);
      const diff = endTime.diff(startTime);
      return moment(diff).format("mm:ss");
    },
    handleSelectChange(val) {
      if (this.$route.participantId !== val) {
        this.$router.replace(
          `/test/${this.$route.params.id}/participant/${val.value}/recording`
        );
      }
    },
  },
  computed: {
    ...mapState({
      testState: (state) => state.test,
    }),
  },
};
</script>
